import React from 'react';
import { Text, TextAs, TextSizes, Tooltip } from '@clockout-dev/design-elements';
import { getJourneyStage } from './journeyStageTag.constants';
import styles from '../../common/styles/status-pill-tag.module.scss';

/**
 * Pill that renders a JOURNEY STAGE value (Users table column, detail panel
 * Status row). Label, tone and the hover definition all come from
 * `journeyStageTag.constants` — the single stage vocabulary. An unrecognised
 * value renders as "Unknown" with the raw value in the tooltip, never as
 * another stage.
 *
 * @param {Object} props
 * @param {string} [props.stage] - `record.journeyStage`
 * @param {string} [props.label] - manual override of the visible label
 */
function JourneyStageTag({ stage, label }) {
    const entry = getJourneyStage(stage);
    const finalLabel = label || entry.label;

    return (
        <Tooltip title={entry.description} placement="top">
            <Text
                as={TextAs.SPAN}
                size={TextSizes.EXTRA_SMALL}
                className={`${styles.tag} ${styles[`tone_${entry.tone}`]}`}
                aria-label={`Journey stage: ${finalLabel}`}
            >
                {finalLabel}
            </Text>
        </Tooltip>
    );
}

export default JourneyStageTag;
